import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type { BackupsOverview } from "@/lib/types";

const KEY = ["admin", "backups"];

// Admin-only. No polling: an admin opening Settings is the trigger. Detection
// of a failed backup belongs to ntfy (NTFY_URL in /opt/flow/.env), not to a
// panel nobody has open.
export function useBackups() {
  return useQuery<BackupsOverview>({
    queryKey: KEY,
    queryFn: () => api.getBackups(),
    staleTime: 60_000,
  });
}
